import * as yup from 'yup'

const schema = yup.object({
  bannerIds: yup
    .array()
    .of(yup.object())
    .required('Selecione pelo menos um banner')
    .typeError('Selecione pelo menos um banner'),
  reportSelected: yup.string().required('Selecione um tipo de relatório'),
})

export default schema
